import { useEffect, useState } from 'react'
import { HomeMetric } from '@/components/ui/home/HomeMetrics'
import { HomeHeroSection } from '@/components/ui/home/HomeHeroSection'
import { LiveIdeasSection } from '@/components/ui/home/LiveIdeasSection'
import { CategorySpotlightCarousel } from '@/components/ui/home/CategorySpotlightCarousel'
import { TestimonialsCarousel } from '@/components/ui/home/TestimonialsCarousel'
import { IdeasMovingFastBanner } from '@/components/ui/home/IdeasMovingFastBanner'
import { HowItWorksSection } from '@/components/ui/home/HowItWorksSection'
import { fetchHome } from '@/services/ideasService'

const DEFAULT_METRICS: HomeMetric[] = [
  { value: 0, label: 'Ideas Submitted' },
  { value: 0, label: 'Active Validators' },
  { value: 0, label: 'Ideas This Week' },
]

export const HomeSection = () => {
  const [metrics, setMetrics] = useState<HomeMetric[]>(DEFAULT_METRICS)

  useEffect(() => {
    fetchHome()
      .then((d) => {
        setMetrics([
          { value: d.total_ideas_submitted ?? 0, label: 'Ideas Submitted' },
          { value: d.total_validators ?? 0, label: 'Active Validators' },
          { value: d.ideas_submitted_this_week ?? 0, label: 'Ideas This Week' },
        ])
      })
      .catch(() => {
        // silently keep default 0s if API fails
      })
  }, [])

  return (
    <div className="relative w-full overflow-x-hidden bg-[var(--background)]">
      <HomeHeroSection metrics={metrics} />

      <div className="relative flex flex-col">
        <HowItWorksSection />
        <CategorySpotlightCarousel />
        <LiveIdeasSection />
        <div className="flex flex-col [&>section+section]:-mt-2 [&>section+section]:sm:-mt-3">
          <TestimonialsCarousel />
          <IdeasMovingFastBanner ideasSubmittedTotal={metrics[0]?.value ?? 0} />
        </div>
      </div>
    </div>
  )
}
